const DEFAULT_LOGIN_SCOPE = 'email,user_location'
const DEFAULT_FIELDS =
  'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email'

class Facebook {
  constructor(fb) {
    if (typeof fb === 'undefined') {
      throw new Error('The Facebook API is not initialized!')
    }

    this.fb = fb
  }

  profile = () => {
    return new Promise((resolve, reject) => {
      this.fb.api('/me', { fields: DEFAULT_FIELDS }, ({ error, ...profile }) => {
        if (error) return reject(new Error('We were unable to retrieve your profile from Facebook'))

        return resolve(profile)
      })
    })
  }

  loginStatus = () => new Promise(resolve => this.fb.getLoginStatus(resolve))

  login = ({ scope = DEFAULT_LOGIN_SCOPE, auth_type = '' } = {}) => {
    return new Promise(async (resolve, reject) => {
      const { status, authResponse } = await this.loginStatus()

      if (status === 'connected') {
        return resolve(authResponse)
      }

      this.fb.login(
        async ({ status, authResponse }) => {
          if (status === 'connected') {
            resolve(authResponse)
          } else {
            reject(new Error('We were unable to authenticate you on Facebook'))
          }
        },
        { scope, auth_type }
      )
    })
  }

  logout = async () => {
    const { status } = await this.loginStatus()

    if (status === 'connected') {
      return this.fb.logout()
    }
  }

  share = async href => {
    return new Promise(resolve => {
      this.fb.ui(
        {
          method: 'share',
          href,
        },
        resolve
      )
    })
  }
}

export default Facebook
